/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Not_FoundInputs */

const en_page_not_found = /** @type {(inputs: Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page Not Found`)
};

const es_page_not_found = /** @type {(inputs: Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página no encontrada`)
};

const fr_page_not_found = /** @type {(inputs: Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page non trouvée`)
};

const de_page_not_found = /** @type {(inputs: Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite nicht gefunden`)
};

const ja_page_not_found = /** @type {(inputs: Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ページが見つかりません`)
};

const zh_page_not_found = /** @type {(inputs: Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页面未找到`)
};

const ar_page_not_found = /** @type {(inputs: Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصفحة غير موجودة`)
};

const id_page_not_found = /** @type {(inputs: Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman Tidak Ditemukan`)
};

const it_page_not_found = /** @type {(inputs: Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina Non Trovata`)
};

const ru_page_not_found = /** @type {(inputs: Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страница не найдена`)
};

const pt_page_not_found = /** @type {(inputs: Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página Não Encontrada`)
};

const ko_page_not_found = /** @type {(inputs: Page_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`페이지를 찾을 수 없습니다`)
};

/**
* | output |
* | --- |
* | "Page Not Found" |
*
* @param {Page_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const page_not_found = /** @type {((inputs?: Page_Not_FoundInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Not_FoundInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_page_not_found(inputs)
	if (locale === "es") return es_page_not_found(inputs)
	if (locale === "fr") return fr_page_not_found(inputs)
	if (locale === "de") return de_page_not_found(inputs)
	if (locale === "ja") return ja_page_not_found(inputs)
	if (locale === "zh") return zh_page_not_found(inputs)
	if (locale === "ar") return ar_page_not_found(inputs)
	if (locale === "id") return id_page_not_found(inputs)
	if (locale === "it") return it_page_not_found(inputs)
	if (locale === "ru") return ru_page_not_found(inputs)
	if (locale === "pt") return pt_page_not_found(inputs)
	return ko_page_not_found(inputs)
});